module.exports = __webpack_public_path__ + "img/accept-mark.29ab5a52.svg";